import { applyFiltersOnData } from 'hooks/useFilters/useFilters';
import { useCasesQuery } from 'queries/cases/queries';
import { caseOpenStatus, caseTabs } from 'queries/cases/types';
import { useMemo } from 'react';

export function useCaseOpenedCount(assetId: string) {
  const { data } = useCasesQuery({
    filters: { activeTab: caseTabs.all, assets_id: [assetId] },
  });
  const count = useMemo(() => {
    if (!data) return 0;
    const filteredData = applyFiltersOnData({ status: caseOpenStatus }, data);
    return filteredData.length;
  }, [data]);

  return count;
}
